import React from 'react';
import styled from '@emotion/styled';
import type { MinWidthProps, SizeProps, SpaceProps } from 'styled-system';
import { minWidth, size, space } from 'styled-system';

import type { FillProps } from '../../theme/system-types';
import { fill } from '../../theme/system-utilities';
import Icon from '../Icon';

interface RadioIconProps {
  checked: boolean;
  iconSize?: number;
  className?: string;
}

type StyleProps = SpaceProps & SizeProps & MinWidthProps & FillProps;

const DEFAULT_ICON_SIZE = 24;

const StyledIcon = styled(Icon)<StyleProps>`
  ${space};
  ${size};
  ${minWidth};
  ${fill};

  transition: fill 0.3s ease-in-out;
`;

const RadioIcon = ({
  iconSize = DEFAULT_ICON_SIZE,
  checked,
  ...props
}: RadioIconProps & StyleProps) => (
  <StyledIcon
    {...props}
    name={checked ? 'radioSelected' : 'radioDefault'}
    size={iconSize}
    minWidth={iconSize}
    fill="transparent"
  />
);

export default RadioIcon;
